// extracted by mini-css-extract-plugin
module.exports = {"banner":"style_banner__1aCQs","isCenter":"style_isCenter__2VU00","bannerInfoBox":"style_bannerInfoBox__bMKGE"};